import { useState, /* useEffect*/ } from 'react';
import { Modal, Button, LoadingIcon } from '@prosolve/common-components-ui'
import FileUpload from '../../sharedComponents/FileUpload'
import useDataConsultNotes from '../../../dataHooks/useDataConsultNotes'
import { FaCloudUploadAlt, FaTrash } from "react-icons/fa";
import { IoDocuments } from "react-icons/io5";
import { getApiBaseUrl } from '../../../utils'

export default ({
  eventId,
  consultNotesUrl: consultNotesUrlRaw,
  isIconOnly,
  isReadOnly
}) => {
  // Ensure null value sets us to an empty string default
  const initConsultNotesUrl = consultNotesUrlRaw || '';

  const [consultNotesUrl, setConsultNotesUrl] = useState(initConsultNotesUrl)

  const {
    deleteConsultNote,
    uploadConsultNotes
  } = useDataConsultNotes();

  const [notesOpen, setNotesOpen] = useState(false)

  const [uploadOpen, setUploadOpen] = useState(false)
  const [files, setFiles] = useState([]);
  const [isBusy, setIsBusy] = useState(false);

  const apiBaseUrl = getApiBaseUrl();

  const filePrefix = `${apiBaseUrl}/file/star/consultNotes/`

  const getConsultNoteControlComponent = (fullUrl = '') => {
    const folderAndfileStartIndex = fullUrl.indexOf(filePrefix) + filePrefix.length
    const folderAndFilename = fullUrl.substring(folderAndfileStartIndex)
    // true filename will be after the eventId/ folder id
    const filename = folderAndFilename.substring(folderAndFilename.indexOf('/') + 1)
    // User uploaded name always after timestamp_ pattern
    const displayName = filename.substring(filename.indexOf('_') + 1)

    return (
      <div key={filename} style={{
        display: 'flex',
        flex: 1,
      }}>
        <div
          style={{
            flex: 1,
            marginRight: '10px',
            color: '#0280c6',
            fontStyle: 'italic',
            textDecoration: 'underline',
            fontSize: '14px',
            cursor: 'pointer',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            minWidth: '0px'
          }}
          onClick={() => window.open(fullUrl, "_blank")}
        >
          {displayName}
        </div>
        {!isReadOnly &&
          <Button
            style={{
              display: 'inline-flex',
              border: 'none',
              position: 'relative',
              color: '#ef0c0c'
            }}
            onClick={() => peformConsultNotesDelete(eventId, filename)}
          >
            <FaTrash style={{ marginRight: '10px' }} />
            <span style={{}}>{'Delete'}</span>
          </Button>
        }
      </div>
    )
  }

  const onClickSubmit = async () => {
    if (files && files.length > 0) {
      setIsLoading(true)
      setIsBusy(true)
      try {
        const response = await uploadConsultNotes(eventId, files)
        const { urls } = response;
        setConsultNotesUrl(urls)
      } catch (e) {
        console.log(e)
      }
      setIsBusy(false)
      setIsLoading(false)
    }
    setUploadOpen(false)
  }

  const onFilesChanged = (filesUpdated = []) => {
    setFiles(filesUpdated)
  }

  const [isLoading, setIsLoading] = useState(false);
  // const [consultNotes, setConsultNotes] = useState([])

  const peformConsultNotesDelete = async (eventId, fileName) => {
    setIsLoading(true)
    try {
      const response = await deleteConsultNote(eventId, fileName);
      const { urls } = response;
      setConsultNotesUrl(urls)
    } catch (e) {
      console.log(e)
    }
    setIsLoading(false)
  }

  const notesFooter = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={() => setNotesOpen(false)}>
        {'Close'}
      </Button>
      {!isReadOnly &&
        <Button
          style={{
            display: 'inline-flex',
            flexDirection: 'row',
            padding: '3px 5px',
            // border: 'none',
          }}
          onClick={() => {
            if(!isLoading) {
              setUploadOpen(true)
            }
          }}
        >
          <FaCloudUploadAlt style={{ color: '#0280c6', fontSize: '18px', marginRight: '5px' }} />
          <span style={{ color: '#565656', fontSize: '14px' }}>{'Upload Consult Note'}</span>
        </Button>
      }
    </div>
  )

  const uploadFooter = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={() => setUploadOpen(false)}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy || files.length < 1}>
        {'Submit'}
      </Button>
    </div>
  )

  const seperator = '<|v|>'
  const allConsultNotesUrls = consultNotesUrl.split(seperator).filter(Boolean)

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center'
    }}>
      {
        notesOpen &&
        <Modal title='Consult Notes' isAutoHeight={true} onClose={() => setNotesOpen(false)} footer={notesFooter}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '15px'
          }}>
            {
              isLoading ?
              <div style={{
                display: 'flex',
                justifyContent: 'center'
              }}>
                <LoadingIcon />
              </div>
              :
              allConsultNotesUrls.length > 0 ?
              allConsultNotesUrls.map(fullUrl => {
                return getConsultNoteControlComponent(fullUrl)
              })
              :
              <div style={{
                fontStyle: 'italic',
                color: '#404040'
              }}>
                {'Click the upload button below to attach consult notes'}
              </div>
            }
          </div>
        </Modal>
      }
      {
        uploadOpen &&
        <Modal title='Upload Images' isAutoHeight={true} onClose={() => setUploadOpen(false)} footer={uploadFooter}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '15px'
          }}>
            <FileUpload
              onFilesChanged={onFilesChanged}
              allowedFileTypes={['application/pdf']}
              // isSingleFile={true}
            />
          </div>
        </Modal>
      }
      <Button 
        style={{
          display: 'inline-flex',
          padding: '8px 16px',
          gap: '10px'
        }}
        onClick={() => !isLoading && setNotesOpen(true)}
        $disabled={isLoading}
      >
        <IoDocuments style={{ color: '#0280c6' }} />
        {!isIconOnly &&
          <span style={{ fontWeight: 'bold', color: '#565656' }}>{'Consult Notes'}</span>
        }
      </Button>
    </div>
  )
}